import { useCallback, useEffect, useMemo, useState } from "react";
import { DEFAULT_ANNOTATION_COUNTS, annotationKeys } from "../utils/constants";

export const useTenantConfig = (activeCase) => {
  const [selfManaged, setSelfManaged] = useState(!!activeCase?.selfManaged);
  const [annotationCounts, setAnnotationCounts] = useState(
    activeCase?.annotationTagsCount || DEFAULT_ANNOTATION_COUNTS
  );

  useEffect(() => {
    setSelfManaged(!!activeCase?.selfManaged);
    setAnnotationCounts(activeCase?.annotationTagsCount || DEFAULT_ANNOTATION_COUNTS);
  }, [activeCase]);

  useEffect(() => {
    if (!selfManaged) return;

    setAnnotationCounts((prev = {}) => {
      let hasChange = false;
      const nextCounts = { ...prev };

      annotationKeys.forEach(({ key }) => {
        const defaultValue = DEFAULT_ANNOTATION_COUNTS[key];
        if (nextCounts[key] !== defaultValue) {
          nextCounts[key] = defaultValue;
          hasChange = true;
        }
      });

      return hasChange ? nextCounts : prev;
    });
  }, [selfManaged]);

  const handleAnnotationCountChange = useCallback((key, value) => {
    const numericValue = Number(value);
    setAnnotationCounts((prev) => ({
      ...prev,
      [key]: Number.isNaN(numericValue) ? 0 : Math.max(0, numericValue),
    }));
  }, []);

  const selfManagedOption = useMemo(
    () => ({ value: "selfManaged", display: "Enable self-managed overrides" }),
    []
  );

  return {
    selfManaged,
    setSelfManaged,
    annotationCounts,
    handleAnnotationCountChange,
    selfManagedOption,
  };
};


